import { useMemo } from 'react';
import {
  useConsultantOrgApi,
  useConsultantWorkspacesApi,
  useConsultantUpdatesApi,
  useConsultantUpsertSummaryApi,
  useConsultantUploadFileApi,
  useConsultantDeleteFileApi,
  useConsultantTriageUpdatesApi,
  useConsultantTriageApi,
} from '@/api/consultant';

export const useConsultantOrgService = (orgId: string | undefined) => {
  const { data, isPending } = useConsultantOrgApi(orgId);
  return {
    org: data ?? null,
    isLoading: isPending,
  };
};

export const useConsultantWorkspacesService = (orgId: string | undefined) => {
  const { data, isPending } = useConsultantWorkspacesApi(orgId);
  return {
    workspaces: useMemo(() => data ?? [], [data]),
    isLoading: isPending,
  };
};

export const useConsultantUpdatesService = (
  orgId: string | undefined,
  query: {
    fromDate?: string;
    toDate?: string;
    source?: string;
    geography?: string;
    kind?: string;
    documentType?: string;
  }
) => {
  const { data, isPending, isFetching } = useConsultantUpdatesApi(orgId, query);
  return {
    updates: useMemo(() => data ?? [], [data]),
    isLoading: isPending,
    isFetching,
  };
};

export const useConsultantUpsertSummaryService = () => {
  const mutation = useConsultantUpsertSummaryApi();
  return {
    upsertSummary: mutation.mutate,
    isPending: mutation.isPending,
  };
};

export const useConsultantTriageUpdatesService = (
  orgId: string | undefined,
  query: {
    fromDate?: string;
    toDate?: string;
    source?: string;
    geography?: string;
    kind?: string;
    documentType?: string;
  }
) => {
  const { data, isPending, isFetching } = useConsultantTriageUpdatesApi(
    orgId,
    query
  );
  return {
    updates: useMemo(() => data ?? [], [data]),
    isLoading: isPending,
    isFetching,
  };
};

export const useConsultantTriageService = () => {
  const mutation = useConsultantTriageApi();
  return {
    triage: mutation.mutate,
    isPending: mutation.isPending,
  };
};

export const useConsultantFileService = () => {
  const uploadMutation = useConsultantUploadFileApi();
  const deleteMutation = useConsultantDeleteFileApi();
  return {
    uploadFile: uploadMutation.mutate,
    deleteFile: deleteMutation.mutate,
    isUploading: uploadMutation.isPending,
    isDeleting: deleteMutation.isPending,
  };
};
